export const SAVE_COMPONENTS_START: string = "SAVE_COMPONENTS_START";
export const SAVE_COMPONENTS_FINISH: string =
    "SAVE_COMPONENTS_FINISH";
export const SAVE_COMPONENTS_REJECTED: string =
    "SAVE_COMPONENTS_REJECTED";